module.exports = __webpack_public_path__ + "static/img/n1_18.38adb96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n1_18.jpg
// module id = S0XL
// module chunks = 2